import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageToggle from './LanguageToggle';
import ResponsiveImage from './ResponsiveImage';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { t, localizedPath } = useLanguage();

  const isActive = (path) => location.pathname === localizedPath(path);

  return (
    <header className="header">
      <div className="container">
        <div className="nav-wrapper">
          <Link to={localizedPath('/')} className="logo">
          <ResponsiveImage
              src="/images/logo.webp"
              alt="Radix Technologies Logo"
              width="120"
              height="30"
              style={{ objectFit: 'contain' }}
          />
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><Link to={localizedPath('/about')} className={`nav-link all-transition focus-color-ring ${isActive('/about') ? 'active' : ''}`}>{t('nav.about')}</Link></li>
              <li><Link to={localizedPath('/services')} className={`nav-link all-transition focus-color-ring ${isActive('/services') ? 'active' : ''}`}>{t('nav.services')}</Link></li>
              <li><Link to={localizedPath('/blog')} className={`nav-link all-transition focus-color-ring ${isActive('/blog') ? 'active' : ''}`}>{t('nav.blog')}</Link></li>
              <li><Link to={localizedPath('/portfolio')} className={`nav-link all-transition focus-color-ring ${isActive('/portfolio') ? 'active' : ''}`}>{t('nav.portfolio')}</Link></li>
              <li><Link to={localizedPath('/careers')} className={`nav-link all-transition focus-color-ring ${isActive('/careers') ? 'active' : ''}`}>{t('nav.careers')}</Link></li>
              <li><Link to={localizedPath('/plans')} className={`nav-link all-transition focus-color-ring ${isActive('/plans') ? 'active' : ''}`}>{t('nav.plans')}</Link></li>
              <li><LanguageToggle /></li>
              <li><Link to={localizedPath('/contact')} className="btn-primary focus-color-ring nav-cta">{t('nav.contact')}</Link></li>
            </ul>
          </nav>

          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
